import { LoadingButton } from "@mui/lab";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { StyledTextField } from "../../pages/login";
import { editHeroSchema } from "../../schema";
import { useUpdateLeaderMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

function EditHeroDialog({ hero, onClose }: any) {
  const { enqueueSnackbar } = useSnackbar();
  const [updateLeader] = useUpdateLeaderMutation();

  const formik = useFormik({
    initialValues: {
      hero,
    },
    validationSchema: editHeroSchema,
    onSubmit: async (values) => {
      try {
        await updateLeader(values.hero).unwrap();
        enqueueSnackbar("updated your hero", {
          variant: "success",
        });
        onClose();
      } catch (error) {
        console.error(error);
        enqueueSnackbar("failed to update your hero", {
          variant: "error",
        });
      }
    },
  });

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit hero</Typography>
      </CustomDialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <FormControl fullWidth variant="standard">
            <InputLabel shrink htmlFor="hero" disableAnimation>
              hero
            </InputLabel>
            <StyledTextField
              id="hero"
              name="hero"
              fullWidth
              placeholder="enter your hero"
              value={formik.values.hero}
              onChange={formik.handleChange}
              error={formik.touched.hero && Boolean(formik.errors.hero)}
              helperText={formik.touched.hero && <>{formik.errors.hero}</>}
              sx={{ mb: 1 }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            cancel
          </Button>
          <LoadingButton
            variant="text"
            type="submit"
            loading={formik.isSubmitting}
          >
            update
          </LoadingButton>
        </DialogActions>
      </form>
    </>
  );
}

export default EditHeroDialog;
